import React from 'react';
import TemplatePage from '../../components/TemplatePage/TemplatePage';
import { zoologyData } from '../../data/departmentalData/zoology';

const Zoology = () => {
  return <TemplatePage data={zoologyData} />;
};

export default Zoology;
